import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Control<T> extends Vue {
    @Prop({required: true})
    public readonly value: T | null;

    @Prop({type: Boolean, required: true})
    public readonly validate: boolean;

    @Prop({type: String, required: true})
    public readonly label: string;

    /**
     * This method must be called every time value related inner state is changed
     */
    protected updateValue(): void {
        const value = this.getValue();
        const isValid = this.validateCurrentValue();

        this.$emit('input', isValid ? value : null);
        this.$emit('validated', isValid);
    }

    /**
     * Returns true if given value is considered valid, false otherwise
     */
    protected validateCurrentValue(): boolean {
        return true;
    }

    /**
     * Returns value that is currently filled in control
     *
     * This can return either value, null when value is not filled.
     * Anything can be returned when control state is invalid.
     */
    protected getValue(): T | null {
        return null;
    }

    protected isInvalid(): boolean {
        return this.validate;
    }
}
